import { Icon } from "@/shared/components/ui/icon";
import { cn } from "@/shared/utils";
import * as React from "react";
import { ReactNode } from "react";

type ChipProps = {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    className?: string;
};

export function Chip({ label, checked, onChange, className }: ChipProps) {
    return (
        <label
            className={cn(
                "text-s text-content-emphasis rounded-m active:bg-pressed hover:bg-hover active: border-emphasis has-[input:focus-visible]:outline-offfset-1 has-[:checked]:bg-selected-default flex items-center gap-1 border px-3 py-[5.5px] font-medium transition-colors select-none has-[input:focus-visible]:outline-2",
                className
            )}
        >
            {checked && <Icon name="check" strokeWidth="thick" size="xs" />}
            {label}
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                className="sr-only"
                onKeyDown={(e) => {
                    // allow toggling the chip by pressing enter, to align with the behavior of the tractie chip component
                    if (e.key === "Enter") {
                        e.preventDefault();
                        onChange(!checked);
                    }
                }}
            />
        </label>
    );
}

type DismissableChipProps = {
    label: ReactNode;
    checked: boolean;
    toggle?: () => void;
    className?: string;
};

export function DismissableChip({ label, checked, toggle, className, ...props }: React.ComponentProps<"span"> & DismissableChipProps) {
    return (
        <span
            className={cn(
                "text-s text-content-emphasis leading-l rounded-m bg-alpha-subtle flex items-center gap-1 px-2 py-[5.5px] font-medium text-nowrap",
                className
            )}
            {...props}
        >
            {label}
            <input type="checkbox" checked={checked} onChange={toggle} className="sr-only" />
            {checked && <Icon name="close" strokeWidth="thick" size="xs" onClick={toggle} className="hover:bg-hover" />}
        </span>
    );
}
